module.exports = __webpack_public_path__ + "static/media/20ECE1.0f9d9374.jpg";